import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import SelectBrokerPopup from "../SelectBrokerPopup";
import AuthPopUp from "../AuthPopUp";
import ForgotPasswordPopup from "../ForgotPasswordPopup";
import useBroker from "src/hooks/useBroker";

const useStyles = makeStyles((theme) => ({
  root: {},
}));

type popupType =
  | "close"
  | "decision"
  | "login"
  | "regis"
  | "forgot"
  | "selectBroker";

const POPUP = {
  close: "close",
  decision: "decision",
  login: "login",
  regis: "regis",
  forgot: "forgot",
  selectBroker: "selectBroker",
};

interface AuthenPopupProps {
  open: boolean;
  onClose: () => void;
  initialPopup?: popupType;
}
const AuthenPopup: React.FC<AuthenPopupProps> = ({
  open,
  onClose,
  initialPopup,
}) => {
  const broker = useBroker()?.broker;
  const classes = useStyles();

  const [currentPopup, setCurrentPopup] = useState<popupType>("close");

  const [brokerName, setBrokerName] = useState(broker?.name);
  const [brokerID, setBrokerID] = useState(broker?.brokerID);

  useEffect(() => {
    if (open) {
      resetState();
      setCurrentPopup("decision");
    }

    if (!open) {
      setCurrentPopup("close");
    }
    //eslint-disable-next-line
  }, [open]);

  useEffect(() => {
    if (currentPopup === POPUP.decision) {
      if (initialPopup) setCurrentPopup(initialPopup);
      else setCurrentPopup("login");
    }
  }, [currentPopup, brokerID, initialPopup]);

  const resetState = () => {
    setCurrentPopup("close");
    setBrokerName(broker?.name);
    setBrokerID(broker?.brokerID);
  };

  const handleSwitch = () => {
    if (currentPopup === POPUP.login) setCurrentPopup("regis");
    if (currentPopup === POPUP.regis) setCurrentPopup("login");
  };

  const handleClose = () => {
    onClose();
  };

  const openInitialPopup = () => {
    if (initialPopup) return setCurrentPopup(initialPopup);
    return setCurrentPopup("login");
  };

  const onSelectBroker = (brokerName: string, brokerID: string) => {
    setBrokerName(brokerName);
    setBrokerID(brokerID);

    openInitialPopup();
  };

  return (
    <div className={classes.root}>
      <SelectBrokerPopup
        open={currentPopup === POPUP.selectBroker}
        onClose={handleClose}
        onClickBroker={onSelectBroker}
      />
      <AuthPopUp
        open={[POPUP.login, "regis"].includes(currentPopup)}
        handleClose={handleClose}
        isLogIn={currentPopup === POPUP.login}
        handleSwitch={handleSwitch}
        openForgot={() => setCurrentPopup("forgot")}
      />
      <ForgotPasswordPopup
        open={currentPopup === POPUP.forgot}
        handleClose={handleClose}
        openLogin={() => setCurrentPopup("login")}
        brokerName={brokerName}
        brokerID={brokerID}
      />
    </div>
  );
};

export default AuthenPopup;
